import React, { FC, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import AudioComponent from "./audioComponent";

interface LazyAudioPlayerProps {
    src: string;
    height?: number;
}

const LazyAudioPlayer: FC<LazyAudioPlayerProps> = ({ src, height }) => {
    const [showPlayer, setShowPlayer] = useState<boolean>(false);

    if (!showPlayer) {
        return (
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid',
                borderColor: 'primary.main',

                height: '28px',      
                width: '120px',      

                borderRadius: 1,      
                padding: '8px',       
                cursor: 'pointer',
                gap: '6px',           

            }} onClick={() => setShowPlayer(true)}>
                <IconButton color="primary" size="small">
                    <PlayCircleOutlineIcon />
                </IconButton>
                <Typography variant="body2" color="primary">Play Audio</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <AudioComponent src={src} height={height} /> 
        </Box>
    );
};

export default LazyAudioPlayer;
